// extracted by mini-css-extract-plugin
export default {"pause":"PauseBtn_pause__T1V-b","btnAnimation":"PauseBtn_btnAnimation__yyDT2","pause__G":"PauseBtn_pause__G__Aa8G-"};